import OSS from "ali-oss";
/*
 *
 * 手机号
 * GZ
 * */
function isPhone(tel: string) {
  return !!tel
    .toString()
    .match(
      /^(0|86|17951)?(13[0-9]|15[012356789]|17[678]|18[0-9]|14[57])[0-9]{8}$/
    );
}
/*
 *
 * 身份证号码为15位或者18位，15位时全为数字，18位前17位为数字，最后一位是校验位，可能为数字或字符X
 * GZ
 *
 * */
function isCardNo(card: string) {
  return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(card.toString());
}

/*
 *
 *
 * OSS 配置
 * */

function OSSConfig() {
  return new OSS({
    region: "oss-cn-hangzhou",
    // accessKeyId: "LTAI4FqmWFQPa2vNK7QvPrzF",
    accessKeyId:'LTAI5t6FZ2W8yFZJHg1XsWPX',
    accessKeySecret: "qDEPx6TODI2vU0KqrDEkIA0xltbUC2",
    // stsToken: '',
    bucket: "magex"
  });
}

/*
 *
 * 时间大小对比
 * */
function TimeSzie(first: string | Date, last: string | Date) {
  let datasTime = new Date(first).getTime();
  let valueTime = new Date(last).getTime();
  if (datasTime > valueTime) {
    return true;
  }
  return false;
}

/*
 *
 * 数字校验
 *
 * */

function isNumber(data: string) {
  return /^[0-9]*$/.test(data);
}

/*
 *
 * 中文匹配
 * */

function isChinese(data: string) {
  return /[\u4e00-\u9fa5]/.test(data);
}

/*
 *
 * 中文与字母匹配
 * */
function isW(data: string) {
  return /^[a-zA-Z\u4e00-\u9fa5]+$/.test(data);
}

/*
 * 数字字母匹配
 *
 * */
function isNumber_AZ(data: string) {
  return /^[a-zA-Z\d]+$/.test(data);
}
/*
 * 数字字母匹配下划线
 *
 * */
function isNumber_AZ_(data: string) {
  return /^[a-zA-Z\d_]+$/.test(data);
}
/**
 * 中文字母数字匹配
 */
function isNumber_AZ_Chinese(data: string) {
  return /^[a-zA-Z\d\u4e00-\u9fa5]+$/.test(data);
}

/**
 * 中文字母数字匹配并且加入括号
 */
function isNumber_AZ_Chinese_Ni(data: string){
  return /^[\(\)\）\）a-zA-Z\d\u4e00-\u9fa5]+$/.test(data);
}

/*数字小数点校验*/
function circleNumber(data: string) {
  return /^\d+(\.\d+)?$/.test(data);
}

/*银行卡判断*/
function bankCardReg(data: string) {
  return /^([1-9]{1})(\d{15}|\d{18})$/.test(data);
}
/**邮箱检测 */
function isEmail(data: string) {
  return /^[0-9A-Za-z][\.-_0-9A-Za-z]*@[0-9A-Za-z]+(\.[0-9A-Za-z]+)+$/.test(
    data
  );
}
/*经度校验*/
function latJ(data: string) {
  return /^-?((0|1?[0-7]?[0-9]?)(([.][0-9]{1,8})?)|180(([.][0]{1,8})?))$/.test(
    data
  );
}

/*纬度校验*/
function latW(data: string) {
  return /^-?((0|[1-8]?[0-9]?)(([.][0-9]{1,8})?)|90(([.][0]{1,8})?))$/.test(
    data
  );
}
function isNumber_AZ_Special(val:string){
  // 匹配数字、字母和特殊字符
  return /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-])|(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-])|(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-])/.test(val);
  // return /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-])/.test(val);
}

/*商品名称校验 */
function validate_shopName(value: string) {
  return /^[a-zA-Z\d\u4e00-\u9fa5\-\_\(\)\[\]\（\）\【\】\{\}]+$/.test(value);
}
/*2位小数校验 */
function validate_decimal(value: string) {
  return /^\d+\.?\d{0,2}$/.test(value);
}
//一位小数校验
function validate_decimal_one(value: string) {
  return /^\d+\.?\d{0,1}$/.test(value);
}
//验证座机
function validate_landline(value: string){
  return /^0\d{3}-\d{7,8}$/.test(value);
}
//验证手机号
function validate_mobile(value: string) {
  return /^1\d{10}$/.test(value);
}

export {
  isPhone,
  isCardNo,
  OSSConfig,
  TimeSzie,
  isNumber,
  isChinese,
  isW,
  isEmail,
  isNumber_AZ,
  isNumber_AZ_Chinese,
  circleNumber,
  bankCardReg,
  latJ,
  latW,
  validate_shopName,
  validate_decimal,
  validate_decimal_one,
  validate_landline,
  validate_mobile,
  isNumber_AZ_Chinese_Ni,
  isNumber_AZ_,
  isNumber_AZ_Special
};